import React from 'react'
import { connect } from 'react-redux'
import NoteItem from './Note'
import DayItem from './Day'
import BlockItem from './Block'
import ActivityItem from './Activity'
import ExpenseItem from './Expense'
import CityItem from './City'
import * as RouteActions from '../../ducks/routes'
import Times from './Times'
import { isMobile } from '../../lib/AppTools'

import "./AgendaItem.less"

const subItems = {
  note:     NoteItem, 
  day:      DayItem, 
  activity: ActivityItem, 
  expense:  ExpenseItem, 
  city:     CityItem, 
  block:    BlockItem, 
}

class Item extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      route: "",
      icon: "",
    }
  }
  render() {
    const SelectedItem = subItems[this.props.item.type]
    return (
      SelectedItem
        ? (
          <div>
            <SelectedItem { ...this.props }/>
            {!isMobile() && <Times routeTimes={this.props.routeTimes}/>}
          </div>
        )
        : <div>ERROR: Unknown item type, call Guille ({this.props.item.type})</div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  remove:          (id, itarget, flag)  => dispatch(RouteActions.remove(id, itarget, flag)),
  repeatExpense:   (id, isrc, idst)     => dispatch(RouteActions.repeatExpense(id, isrc, idst)),
  editItem:        (id, itarget, k, v)  => dispatch(RouteActions.editItem(id, itarget, { [k]: v })),
})

export default connect(null, mapDispatchToProps)(Item)